<template>
  <div id="project-special-subject" class="special-subject" data-aos="zoom-in" data-aos-duration="1500">
    <div class="special-subject-row container">
      <MyTitle>
        <template v-slot:title><b style="color: #1E55AE">高油压桨叶调节装置</b>专题</template>
      </MyTitle>
      <div class="special-subject-video">
        <ul class="videos-3d">
          <li>
            <video poster="http://www.energyst.cn/media/article/images/3d_poster_20230506085709_540.jpg"
                   controls="controls" width="700">
              <source src="http://www.energyst.cn/media/article/videos/v.f20_20230506084352_212.mp4" type="video/mp4">
            </video>
            <p>桨叶高油压全自动调节系统三维图 Graphic Model</p>
          </li>
        </ul>
        <ul class="videos-min">
          <li v-for="item in videosList" :key="item.id">
            <video :poster="item.cover_picture"
                   controls="controls">
              <source :src="item.video_url" type="video/mp4">
            </video>
            <p>{{ item.title }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SpecialSubject",
  data() {
    return {
      videosList: [],
    }
  },
  methods: {
    // 请求桨叶调节器视频
    async getSSVideos() {
      const results = await this.$api.reqSSVideos();
      if (results.status === 200) {
        this.videosList = results.results
      } else {
        this.$message({showClose: true, message: "桨叶调节器视频加载失败！", type: 'error'})
      }
    }
  },
  mounted() {
    this.getSSVideos();
  }
}
</script>

<style scoped lang="less">
.special-subject {
  padding: 80px 0;

  .special-subject-row {

    .special-subject-video {
      margin: 70px 0;
      text-align: center;

      p {
        font-size: 20px;
        font-weight: bold;
        line-height: 50px;
      }

      video {
        width: 100%;
        margin-bottom: 10px;
        border-radius: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .5);
      }

      .videos-3d {
        display: flex;
        justify-content: center;

        li {
          width: 700px;
        }
      }

      .videos-min {
        display: flex;
        justify-content: center;
        flex-direction: row;
        flex-wrap: wrap;

        li {
          margin: 80px 20px;
          height: 300px;
          width: 187px;

          p {
            font-size: 15px;
            line-height: 25px;
          }
        }
      }
    }
  }
}
</style>